export default __webpack_public_path__ + "static/media/icon_cancel_black.1f55d3ea.svg";